// R115 calendar hub — the Guests view's primary on a reservation when the guest
// builder's "recovery" action is NOT registered (DECISIONS: "Guest Recovery
// when a ticket exists, else the Issues board"). The moment a 'recovery' stay
// action exists these step aside, so the composer is the one blue button.
import { registerAction, actionsFor, type CalendarCtx, type EntityRef } from '../registry';
import type { Stay } from '../types';
import { OFFICE, views, oneShot } from './util';

const stayOf = (ref: EntityRef, data: unknown, ctx: CalendarCtx): Stay | null => {
  const d = data as { stay?: Stay } | Stay | null;
  const fromData = d && (d as { stay?: Stay }).stay ? (d as { stay: Stay }).stay : (d && (d as Stay).id === ref.id ? (d as Stay) : null);
  return fromData || ctx.data.stays.find(s => s.id === ref.id) || null;
};
const noRecovery = (ctx: CalendarCtx) => !actionsFor('stay', ctx.role).some(a => a.key === 'recovery');
const ticketOf = (s: Stay | null) => (s && s.flagged && s.flagged.ticket_id ? String(s.flagged.ticket_id) : '');

registerAction({
  key: 'gs_recovery', inspector: 'stay', label: 'Guest Recovery', icon: '🛟', order: 1, roles: OFFICE, primaryIn: views('guests'),
  when: (ref, data, ctx) => ctx.view === 'guests' && noRecovery(ctx) && !!ticketOf(stayOf(ref, data, ctx)),
  run: (ref, data, ctx) => { oneShot('gr_focus', ticketOf(stayOf(ref, data, ctx))); ctx.go('guest-recovery'); },
});
registerAction({
  key: 'gs_issues', inspector: 'stay', label: 'Issues for this home', icon: '⚑', order: 2, roles: OFFICE, primaryIn: views('guests'),
  when: (ref, data, ctx) => { const s = stayOf(ref, data, ctx); return ctx.view === 'guests' && noRecovery(ctx) && !!s && !ticketOf(s); },
  run: (ref, data, ctx) => { const s = stayOf(ref, data, ctx); if (s) oneShot('iss_focus_listing', s.listing_id); ctx.go('issues'); },
});
